import {
  checkConditionAgainstProperty,
  checkConditionAgainstValue
} from 'src/components/collapsible-table/table-data-prep';
import _ from 'lodash';
import {
  Header,
  HeaderOptions,
  ITableData
} from '../../types/generic-table.model';

// eslint-disable-next-line import/prefer-default-export
export function getFormattedValueForInput(
  selectedValue: number,
  numberFormat: string
) {
  if ((selectedValue as unknown as string) === '-') return '-';
  const regexForDecimal = /[0]+$/g;
  const decimalRegexData = regexForDecimal.exec(numberFormat);
  let splittedDecimalData = null;
  if (decimalRegexData && numberFormat.includes('0.')) {
    // eslint-disable-next-line prefer-destructuring
    splittedDecimalData = numberFormat.split('.')[1];
  }

  if (numberFormat.includes('0.')) {
    return splittedDecimalData && splittedDecimalData.length
      ? Math.floor(selectedValue * 10 ** splittedDecimalData.length) /
          10 ** splittedDecimalData.length
      : selectedValue;
  }
  if (numberFormat === '#,###,##0') {
    return Math.round(selectedValue);
  }
  return selectedValue;
}

export const isValueEqual = (
  updatedValue: number | string,
  currentValue: number | string
) => updatedValue !== currentValue;

const changeFunc = (rowData: any, headerMetadata: Header[]) => {
  let changedRow = {};
  headerMetadata
    .filter((headerData: Header) => headerData.parent.section === 'input')
    .forEach((headerData: Header) => {
      if (checkConditionAgainstValue(headerData, rowData, true)) {
        changedRow = Object.assign(changedRow, {
          [headerData.parent.parent_field]:
            rowData.parent.data[headerData.parent.parent_field]
        });
      }
    });
  return changedRow;
};

export function getRowsForUpdatedValue(tableRows: any, headerData: Header[]) {

  const parentFieldToDefault: Record<string, any> = {};
    headerData.forEach(headerEntry => {
      // Check if children exists and iterate over them
      if (headerEntry.children && Array.isArray(headerEntry.children)) {
        headerEntry.children.forEach(child => {
          if (child.parent && child.parent.parent_field) {
            parentFieldToDefault[child.parent.parent_field] = child.parent.default_value;
          }
        });
      }
      // Optional: also check top-level parent if applicable
      if (headerEntry.parent && headerEntry.parent.parent_field) {
        parentFieldToDefault[headerEntry.parent.parent_field] = headerEntry.parent.default_value;
      }
    });
    
  const results = tableRows
    .map((rowData: any) => {
      /* Function to check weather the input value is changed or not */
      // eslint-disable-next-line prefer-const
      let changedInputRow = changeFunc(rowData, headerData);
      // eslint-disable-next-line no-restricted-syntax
      for (const key in changedInputRow) {
        // Check if the value of the current key is equal to the specified value
        if (changedInputRow[key] === '-' || changedInputRow[key] === parentFieldToDefault[key]) {
          // Delete the key from the object
          delete changedInputRow[key];
        }
      }
      if (!_.isEmpty(changedInputRow)) {
        return rowData.children.map((child) => ({
          brand: child.parent.data.brand,
          ppg: child.parent.data.ppg,
          ...changedInputRow
        }));
      }
      return [];
    })
    .flat(1);
  return results;
}

export function resetTopLineInputData(tableRows: any, headerData: Header[]) {
  headerData
    .filter(
      (header) => header.parent.is_visible && header.parent.is_input_enable
    )
    .forEach((inputHeader) =>
      tableRows.forEach(
        // eslint-disable-next-line no-return-assign
        (row: {
          parent: { data: { [x: string]: string | number | boolean } };
        }) =>
          // eslint-disable-next-line no-param-reassign
          (row.parent.data[inputHeader.parent.parent_field] =
            inputHeader.parent.default_value)
      )
    );
  return tableRows;
}
